<template>
    <div class="editor">

        <template v-if="can_edit">

            <div v-if="error=='NAME'" class="alert alert-danger my-2" role="alert">
                {{ lang['module.name_prompt'] }}
            </div>
            <div v-if="error=='NAME_LENGTH'" class="alert alert-danger my-2" role="alert">
                {{ lang['module.name_length_prompt'] }}
            </div>

            <div class="">
                <label for="module-name" class="section-heading">{{ lang['module.name'] }}</label>
                <input id="module-name" class="form-control" type="text" v-model="module.name" @keyup="resetError">
            </div>

            <div v-if="error=='LINK'" class="alert alert-danger my-2 mt-3" role="alert">
                {{ lang['module.link_prompt'] }}
            </div>

            <div class="mt-3">
                <label for="module-link" class="section-heading">{{ lang['module.link_label'] }}</label>
                <input id="module-link" class="form-control" type="text" :title="module.link" v-model="module.link" @keyup="resetError">
            </div>

            <div class="mt-1">
                <a target="blank" :href="module.link">
                    <button type="button" class="btn btn-primary btn-block" :disabled="!module.link || module.link.length == 0 || !isURL(module.link)">{{ lang['module.preview'] }}</button>
                </a>
            </div>

<!--            <div class="edit-row mt-3">-->
<!--                <label for="shared">{{ lang['module.share_with_org'] }}</label>-->
<!--                <label class="switch">-->
<!--                    <input type="checkbox" id="shared" v-model="module.share_with_org">-->
<!--                    <span class="slider-switch round"></span>-->
<!--                </label>-->
<!--            </div>-->

        </template>

        <template v-else>
            <div class="">
                <label class="section-heading">{{ lang['module.name'] }}</label>
                <div>{{ module.name }}</div>
            </div>
            <div class="mt-3" style="word-break: break-word;">
                <label class="section-heading">{{ lang['module.link_label'] }}</label>
                <div>{{ module.link }}</div>
            </div>
            <div class="mt-1">
                <a target="blank" :href="module.link">
                    <button type="button" class="btn btn-primary btn-block">{{ lang['module.preview'] }}</button>
                </a>
            </div>
        </template>

        <template v-if="!module.new_module">
            <label class="section-heading d-flex justify-content-between align-items-center mt-3" @click="collapsed = !collapsed">{{ lang['general.more_info'] }} <i class="expand-options far" :class="{'fa-chevron-down': collapsed, 'fa-chevron-up': !collapsed}"></i></label>
            <div :class="{'options-hidden': collapsed, 'options-visible': !collapsed}">
                <label class="section-heading mt-3">{{ lang['module.original_model'] }}</label>
                <div>{{ module.model.name }}</div>

                <label class="section-heading mt-3">{{ lang['module.used_models'] }}</label>
                <template v-if="use_cases.length > 0">
                    <div class="mb-3" v-for="(use_model, index) in use_cases">
                        <div class="">{{use_model.name}}</div>
                        <div class="small-bold" style="word-break: break-word;" v-for="(use_decision, index) in use_model.decisions">
                            {{ use_decision }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="">{{ lang['general.none'] }}</div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ['content', 'model'],
    data() {
        return {
            module: this.content,
            can_edit: false,
            collapsed: true,
            error: false,
            use_cases: [],
            lang: lang,
        }
    },

	mounted() {
        this.can_edit = false;
        this.use_cases = [];
        if(this.content) {
            this.module = this.content;
            if(+this.module.model_id == +this.model){
                this.can_edit = true;
            }
            if(this.module.uses.length > 0){
                this.module.uses = JSON.parse(JSON.stringify(this.module.uses));
                var use_cases = [];
                this.module.uses.forEach(function(temp_use){
                    if(use_cases.length == 0 || temp_use.id != use_cases[use_cases.length - 1].id){
                        use_cases.push({
                            id: temp_use.id,
                            name: temp_use.name,
                            decisions: []
                        })
                    }
                    use_cases[use_cases.length - 1].decisions.push(temp_use.text);
                });
                this.use_cases = use_cases;
            }
        }
	},

	methods: {

		resetError() {
			this.error = false;
		},

		save() {
			if(!this.module.name || this.module.name.trim().length == 0) {
				this.error = 'NAME';
			} else if (this.module.name.length > 60) {
                this.error = 'NAME_LENGTH';
            } else if (!this.isURL(this.module.link)){
                this.error = 'LINK';
			} else {
				var $this = this;

                $.post('/modules/' + this.model + '/save', {
                        id: this.module.id,
                        decision_id: null,
                        group_id: null,
                        link: this.module.link,
                        name: this.module.name,
                        share_with_org: this.module.share_with_org,
                        prompt: null,
                    }, response => {
                        if(!response.error) {
                            $this.$emit('close');
                        }
                    })
                    .catch((error) => {
                        bus.$emit('popupError', error);
                    });
			}
            //$this.$emit('close');
		},

        isURL(str) {
            if(!str) {
                return false;
            }
            try {
                new URL(str);
                return true;
            }
            catch (_) {
                return false;
            }
        }
},

	watch: {
		searchTerm(val) {
			if(!val.trim().length > 0) {
				this.filteredStudents = this.students;
			} else {
				this.filteredStudents = this.students.filter(student => {
					let studentStr = student.last_name + ',' + student.first_name;
					return studentStr.toLowerCase().includes(val.trim().toLowerCase())
				});
			}
		}
	},

	created() {
		bus.$on('save', this.save);
	},

	beforeDestroy() {
		bus.$off('save', this.save);
		//TODO This needs to change when we get the non D3 drawn model
		$(".nodeRect").attr("style", null);
		$(".link").attr("style", null);
	}
}
</script>
